import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsStagesPlanWorksQualitiControls: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS,
	},
	getRegulationsStagesPlanWorksQualitiControlPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL_PREVIEW,
	},
	getRegulationsStagesPlanWorksQualitiControlPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL_POPUP,
	},
	createRegulationsStagesPlanWorksQualitiControl: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
				.CREATE_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL,
	},
	getRegulationsStagesPlanWorksQualitiControl: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL
	},
	patchRegulationsStagesPlanWorksQualitiControl: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
				.PATCH_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL,
	},
	putRegulationsStagesPlanWorksQualitiControl: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
				.PUT_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL,
	},
	deleteRegulationsStagesPlanWorksQualitiControl: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]
				.DELETE_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL,
	},
}
